// [More info](https://next.router.vuejs.org/api/#history)
export default {
};
